
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/building-whatsapp-chatbot",
      function () {
        return require("private-next-pages/webinars/building-whatsapp-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/building-whatsapp-chatbot"])
      });
    }
  